var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-tree',{attrs:{"data":_vm.tree_list,"props":_vm.defaultProps}}),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.searchHandle}},[_vm._v("查询")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }